export const TIME_FORMAT = 'HH:mm';
export const TIME_PLACEHOLDER = 'hh:mm';
